export const Types = {
    SUBMIT_CREATE_CHALLENGE: "SUBMIT_CREATE_CHALLENGE",
    UPDATE_CHALLENGE_PARAMS: "UPDATE_CHALLENGE_PARAMS",
    CREATE_CHALLENGE_COMPLETE: "CREATE_CHALLENGE_COMPLETE",
    START_CREATE_CHALLENGE: "START_CREATE_CHALLENGE",
    END_CREATE_CHALLENGE: "END_CREATE_CHALLENGE",
    ERROR_CREATING_CHALLENGE: "ERROR_CREATING_CHALLENGE"
};

export const submitCreateChallenge = (permalink, sponsoredType, lang) => ({
    type: Types.SUBMIT_CREATE_CHALLENGE,
    permalink: permalink,
    sponsoredType: sponsoredType,
    lang: lang,
});

export const updateChallengeParams = change => ({
    type: Types.UPDATE_CHALLENGE_PARAMS,
    change
});

export const createChallengeCompleted = (challengeId) => ({
    type: Types.CREATE_CHALLENGE_COMPLETE,
    challengeId: challengeId
});

export const startCreateChallengeAction = () => ({
    type: Types.START_CREATE_CHALLENGE
});

export const endCreateChallengeAction = () => ({
    type: Types.END_CREATE_CHALLENGE
});

export const errorCreatingChallengeAction = (error) => ({
    type: Types.ERROR_CREATING_CHALLENGE,
    error: error
});



// WEBPACK FOOTER //
// ./public/pages/BreakCreator/actions.js